// extracted by mini-css-extract-plugin
export default {"container":"IODetails_container__YZ4iv","breadcrumbBar":"IODetails_breadcrumbBar__noe-M"};